module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-celebrity-box"
  }, [_c('scroller', {
    ref: "scrollerEvent",
    attrs: {
      "lock-x": "",
      "height": _vm.heightData,
      "scrollbarY": ""
    }
  }, [_c('div', {
    ref: "box",
    staticClass: "box"
  }, [(!_vm.isLoadMoreShow) ? _c('card', {
    staticClass: "movie-celebrity"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "previewer-demo-img",
    attrs: {
      "src": _vm.dataList.avatars && _vm.dataList.avatars.medium
    },
    on: {
      "click": function($event) {
        _vm.show()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("姓   名：" + _vm._s(_vm.dataList.name))]), _vm._v(" "), (_vm.dataList.aka) ? _c('p', [_vm._v("曾用名：" + _vm._s(_vm.dataList.aka))]) : _vm._e(), _vm._v(" "), (_vm.dataList.name_en) ? _c('p', [_vm._v("英文名：" + _vm._s(_vm.dataList.name_en))]) : _vm._e(), _vm._v(" "), (_vm.dataList.aka_en) ? _c('p', [_vm._v("其   它：" + _vm._s(_vm.dataList.aka_en))]) : _vm._e(), _vm._v(" "), (_vm.dataList.gender) ? _c('p', [_vm._v("性   别：" + _vm._s(_vm.dataList.gender))]) : _vm._e(), _vm._v(" "), (_vm.dataList.born_place) ? _c('p', [_vm._v("出生地：" + _vm._s(_vm.dataList.born_place))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('cell', {
    staticClass: "info-source",
    attrs: {
      "title": "信息来源",
      "link": _vm.dataList.mobile_url
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('divider', {
    staticClass: "divider"
  }, [_vm._v("作品")]), _vm._v(" "), _vm._l((_vm.dataList.works), function(item) {
    return _c('div', {
      key: item.subject.id,
      on: {
        "click": function($event) {
          _vm.toRoute(item.subject.id)
        }
      }
    }, [_c('masker', {
      ref: "masker",
      refInFor: true,
      staticClass: "masker",
      attrs: {
        "color": "F9C90C",
        "opacity": 0.5
      }
    }, [_c('div', {
      ref: "imgBox",
      refInFor: true,
      staticClass: "img-box",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('img', {
      attrs: {
        "src": item.subject.images.small,
        "alt": "item.alt"
      }
    })]), _vm._v(" "), _c('div', {
      ref: "rightBox",
      refInFor: true,
      staticClass: "right",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('p', [_vm._v("片名：" + _vm._s(item.subject.title))]), _vm._v(" "), _c('p', [_vm._v("年份：" + _vm._s(item.subject.year))]), _vm._v(" "), _c('p', [_vm._v("角色：" + _vm._s(item.roles.join('、')))]), _vm._v(" "), (item.subject.genres.join('、')) ? _c('p', [_vm._v("类型：" + _vm._s(item.subject.genres.join('、')))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("评分：" + _vm._s(item.subject.rating.average))])])])], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.isLoadMoreShow) ? _c('load-more', {
    attrs: {
      "tip": "loading"
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c5a9936"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MovieCelebrity.vue
// module id = 207
// module chunks = 1